import { Col, Form, Input, Row, notification } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { FooterModal } from 'components/templates'
import { useModal } from 'hooks'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuthServices } from 'services'
import styled from 'styled-components'
import { CONDITION_PASSWORD } from 'utils/regularExpressions'

export const StyleForm = styled(Form)`
  padding: 24px;
`
export const StyledInputPassword = styled(Input.Password)`
  :focus {
    border: none !important;
    border-bottom: 1px solid var(--color-primary-109) !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  height: 36px;
  border: none;
  border-bottom: 1px solid var(--color-gray-103);
  border-radius: 0;
  padding: 8px 0;
  &.prevent-edit {
    color: inherit;
    background-color: inherit;
  }
  &.ant-input-affix-wrapper-focused {
    border: none !important;
    border-bottom: 1px solid var(--color-primary-109) !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }
`

const ChangePassword = () => {
  const [form] = useForm()
  const modal = useModal()
  const { changePassword } = useAuthServices()
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const [validateTrigger, setValidateTrigger] = useState(['onBlur'])

  const handleSubmit = async () => {
    setValidateTrigger(['onChange', 'onBlur'])
    const dataForm: any = await form.validateFields()
    setLoading(true)
    changePassword({
      old_password: dataForm['old_password'],
      new_password: dataForm['new_password']
    })
      .then((res) => {
        if (res?._successfully) {
          modal.close(true)
          notification.success({ message: t('change-password-success') })
          setTimeout(() => {
            window.location.assign('/')
          }, 1000)
        }
      })
      .finally(() => setLoading(false))
  }

  const checkRenewPassword = () => {
    const dataForm = form.getFieldsValue()
    return (
      dataForm['re_new_password'] &&
      dataForm['re_new_password'] !== dataForm['new_password']
    )
  }

  return (
    <>
      <StyleForm form={form} validateTrigger={validateTrigger}>
        <Row>
          <Col span={24}>
            <div>{t('old-password')}</div>
            <Form.Item
              name="old_password"
              rules={[
                {
                  required: true,
                  message: t('please-enter-password') || ''
                }
              ]}>
              <StyledInputPassword
                placeholder={t('password')}
                required
                autoComplete="new-password"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <div>{t('new-password')}</div>
            <Form.Item
              name="new_password"
              rules={[
                {
                  required: true,
                  message: t('please-enter-new-password') || ''
                },
                {
                  pattern: CONDITION_PASSWORD,
                  message: t('condition-password') || ''
                }
              ]}>
              <StyledInputPassword
                onBlur={() => setValidateTrigger(['onChange', 'onBlur'])}
                placeholder={t('new-password')}
                required
                autoComplete="new-password"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <div>{t('re-new-password')}</div>
            <Form.Item
              name="re_new_password"
              rules={[
                {
                  required: true,
                  message: t('please-enter-re-new-password') || ''
                },
                {
                  validator: (_: any, value: string) => {
                    if (checkRenewPassword()) {
                      return Promise.reject(t('re-new-password-not-match'))
                    }
                    return Promise.resolve()
                  }
                }
              ]}>
              <StyledInputPassword
                placeholder={t('re-new-password')}
                autoComplete="new-password"
                required
              />
            </Form.Item>
          </Col>
        </Row>
      </StyleForm>
      <FooterModal
        onSubmit={handleSubmit}
        disabled={loading}
        loading={loading}
      />
    </>
  )
}

export default ChangePassword
